export default (state) => {

  const { search, filters, sorting } = state.screens.Subbies.SubValuations

  const params = {
    search,
    sort: sorting.order ? `${sorting.order === 'descend' ? '-' : ''}${sorting.columnKey}` : '-date',
  }

  if (filters.subcontractor_id.length) params['filter[subcontractor_id]'] = filters.subcontractor_id.join(',')
  if (filters.project_id.length) params['filter[project_id]'] = filters.project_id.join(',')
  if (filters.contracts_manager_id.length) params['filter[contracts_manager_id]'] = filters.contracts_manager_id.join(',')
  if (filters.date_range.length) params['filter[date_range]'] = filters.date_range.map(date => date.format('YYYY-MM-DD')).join(',')
  if (filters.to_date_range.length) params['filter[to_date_range]'] = filters.to_date_range.map(date => date.format('YYYY-MM-DD')).join(',')
  if (filters.user_id.length) params['filter[user_id]'] = filters.user_id.join(',')
  if (filters.status.length) params['filter[status]'] = filters.status.join(',')

  return params

}
